import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { AdminRouteGuard } from '../auth/AdminRouteGuard';

const approvalsRouteRef = createRouteRef();

const approvalsPage = PageBlueprint.make({
  params: {
    path: '/aprovacoes',
    title: 'Aprovações',
    icon: <AssignmentTurnedInIcon fontSize="inherit" />,
    noHeader: true,
    routeRef: approvalsRouteRef,
    loader: async () => {
      const { ApprovalsPage } = await import('./ApprovalsPage');
      return (
        <AdminRouteGuard>
          <ApprovalsPage />
        </AdminRouteGuard>
      );
    },
  },
});

export const approvalsPlugin = createFrontendPlugin({
  pluginId: 'aprovacoes',
  title: 'Aprovações',
  icon: <AssignmentTurnedInIcon fontSize="inherit" />,
  routes: {
    root: approvalsRouteRef,
  },
  extensions: [approvalsPage],
});
